import Fetch, { pageInfo } from './fetch';
import Qs from 'qs'

const sanitationManageRequest = {
    houseHealthList (param, page, size) {
        return Fetch({
            url: '/health/houseHealthList?' + Qs.stringify(param) + pageInfo(page, size),
            method: 'get'
        });
    },
    houseHealthGplot (str) {
        return Fetch({
            url: '/health/houseHealthGplot?' + str,
            method: 'get'
        });
    },
    addOne (param) {
        return Fetch({
            url: '/health/addOne',
            data: param,
            method: 'post'
        });
    },
    updateOne (param) {
        return Fetch({
            url: '/health/updateOne',
            data: param,
            method: 'post'
        });
    },
    selectByHealthId (id) {
        return Fetch({
            url: '/health/selectByHealthId?healthId=' + id,
            method: 'get'
        });
    },
    houseHealthListExport (param, page, size) {
        return Fetch({
            url: '/health/houseHealthListExport?' + Qs.stringify(param) + pageInfo(page, size),
            method: 'get',
            responseType: 'arraybuffer'
        });
    },
    houseHealthTotalExport (param, page, size) {
        return Fetch({
            url: '/health/houseHealthTotalExport?' + Qs.stringify(param) + pageInfo(page, size),
            method: 'get',
            responseType: 'arraybuffer'
        });
    },
    houseHealthTotal (param, page, size) {
        return Fetch({
            url: '/health/houseHealthTotal?' + Qs.stringify(param) + pageInfo(page, size),
            method: 'get'
        });
    },
    importHealth (houseId, formData) {
        return Fetch({
            url: '/health/importHealth?houseId=' + houseId,
            method: 'post',
            data: formData,
            headers: { 'Content-Type': 'application/formData' }
        });
    }
}
export default sanitationManageRequest;



// WEBPACK FOOTER //
// ./src/api/sanitationManage.js